import React from 'react';

import { Button } from 'primereact/button';
import { Dropdown } from 'primereact/dropdown';

interface StatusTransition {
  id: number;
  label: string;
}

interface TaskActionsSectionProps {
  possibleStatusTransitions?: StatusTransition[];
  selectedAction: unknown;
  onActionClick: (id: number) => void;
  onActionSelect: (id: number) => void;
}

export const TaskActionsSection: React.FC<TaskActionsSectionProps> = ({
  possibleStatusTransitions,
  selectedAction,
  onActionClick,
  onActionSelect
}) => {
  if (!possibleStatusTransitions || possibleStatusTransitions.length === 0) {
    return null;
  }

  return (
    <div className="grid task-card-transitions-btns__roles">
      <div className="col task-card__column  flex flex-column mr-4">
        <div className="flex flex-column">
          <div className="grid flex justify-content-between align-items-center gap-3 task-card__actions-row">
            <label className="col-fixed fixed-labels task-card__label--action">
              Действия над нарядом:
            </label>
            <div
              className="action-section flex gap-2 col"
              style={{ marginRight: '-14px', padding: '0 0.5rem' }}
            >
              <>
                {possibleStatusTransitions.slice(0, 3).map((action, index) => (
                  <Button
                    className="task-card-transitions-btns__roles"
                    key={index}
                    label={action.label}
                    onClick={() => onActionClick(action.id)}
                    severity="secondary"
                    outlined
                  />
                ))}
                {possibleStatusTransitions.length > 3 && (
                  <Dropdown
                    className="task-card-transitions-btns__roles"
                    value={selectedAction}
                    options={possibleStatusTransitions.slice(3)}
                    onChange={(e) => onActionSelect(e.value.id)}
                    filter
                    placeholder="Выбрать дополнительные действия"
                  />
                )}
              </>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TaskActionsSection;
